import {
    FrontendExperimentsResponse,
    Identifiers
} from "@atlassian/feature-gate-node-client-bootstrapper";

export type FeatureGatesBootstrapValues = FrontendExperimentsResponse & {
    identifiers: Identifiers;
};

declare global {
    interface Window {
        featureGateBootstrapValues: FeatureGatesBootstrapValues;
    }
}

export enum StatsigFeatureGateKey {
    BXPSU_2243_SKIP_SITE_NAME_FEATURE_GATE = "bxpsu-2243_skip_site_name_feature_gate", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2243_skip_site_name_feature_gate
    BXPSU_2854_CONFLUENCE_PUBLIC_LINK = "bxpsu-2854_confluence_public_link", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2854_confluence_public_link
    BXPSU_2930_SITE_PICKER_BXP_UI = "bxpsu-2930_site_picker_bxp_ui" // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2930_site_picker_bxp_ui
}

export enum StatsigExperimentKey {
    BXPSU_2770_SKIP_SITE_NAME_EXPERIMENT_JSW = "bxpsu_2770_jsw_skip_site_name", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu_2770_jsw_skip_site_name
    BXPSU_2243_SKIP_SITE_NAME_EXPERIMENT = "bxpsu-2243_skip_site_name_experiment", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu-2243_skip_site_name_experiment
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW = "bxpsu-2628-remove-bundles-nonpaid-jsw-signup", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu-2628-remove-bundles-nonpaid-jsw-signup
    WAC_SIGNUP_UPGRADE_PATH = "wac_signup_upgrade_path", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac_signup_upgrade_path
    ATLAS_58859_JSW_FIND_USER_SEG_AND_TEMPLATE_REDESIGN = "jsw-user-seg-and-template-redesign-team-24" // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jsw-user-seg-and-template-redesign-team-24/setup
}

// Recommend to prefix cohort names with experiment ticket (ex. expcen-1234_variation-1)
export enum StatsigExperimentCohort {
    UNEXPECTED_FAILURE = "unexpected_failure",
    NOT_ENROLLED = "not_enrolled",
    BXPSU_2243_CONTROL_CONFLUENCE = "bxpsu-2243_control",
    BXPSU_2243_TREATMENT_CONFLUENCE_SKIP_SITE_NAME = "bxpsu-2243_treatment-a-skip-site-name",
    BXPSU_2770_CONTROL_JSW = "bxpsu_2770_control",
    BXPSU_2770_TREATMENT_JSW_SKIP_SITE_NAME = "bxpsu_2770_treatment-a-skip-site-name",
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW_CONTROL = "control",
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW_VARIANT = "bxpsu-2628-remove-bundles",
    WAC_SIGNUP_UPGRADE_PATH_TEST = "test",
    ATLAS_58859_JSW_FIND_USER_SEG_AND_TEMPLATE_REDESIGN_CONTROL = "control",
    ATLAS_58859_JSW_FIND_USER_SEG_AND_TEMPLATE_REDESIGN_TREATMENT = "treatment"
}
